<template>
  <Modal v-model="visible" :title="title" :width="80" :footer-hide="true">
    <div class='page-filter'>
      <Row :gutter="12">
        <Col span="5" :lg="5" :md="8" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.name" placeholder="姓名"></Input>
        </Col>
        <Col span="5" :lg="5" :md="8" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.idCardCode" placeholder="身份证号"></Input>
        </Col>
        <Col span="5" :lg="5" :md="8" :sm="12" :xs="24" class="margin-bottom">
        <Input v-model="params.phone" placeholder="手机号"></Input>
        </Col>
        <Col span="9" :lg="9" :md="24" :sm="12" :xs="24" class="page-action">
        <div>
          <Button type="primary" icon="ios-search" @click="list()">搜索</Button>
          <Button icon="ios-reset" @click="reset()">清空</Button>
        </div>
        </Col>
      </Row>
    </div>
    <div class="pg-bd">
      <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-update="handleChange"></sl-table>
    </div>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
    <debtor-person-bind ref="dpb" @on-select="bind"/>
    
  </Modal>
</template>
<script>
import debtorPersonBind from './debtorPersonBind'
const columns = [
  { title: '姓名', key: 'name', width: 120 },
  { title: '身份证号', key: 'idCardCode', width: 180 },
  { title: '手机号', key: 'phone', width: 120 },
  { title: '住址', key: 'familyAddress' },
  { title: '状态', key: 'stateText', width: 100 },
  { title: '查询时间', key: 'creditInquiryTimeText', width: 120 },
  { title: '征信结果', key: 'lastBankResult', width: 150 },
]
export default {
  components:{ debtorPersonBind },

  data() {
    return {
      loading: false,
      id: null,
      columns: [
        ...columns,
        {
          title: '操作',
          key: 'action',
          width: 80,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            let acts = []
            acts.push(h('a', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  this.viewCreditDetail(params)
                }
              }
            }, '查看'))
            return h('div', acts)
          }
        }
      ],
      orderId: null,
      data: [],
      params: {
        idCardCode: null,
        name: null,
        phone: null,
        state: 2,
        legalName: null,
      },
      page: {
        pageNum: 1,
        pageSize: 8,
        total: 0
      },
      visible: false,
      creditVisible:false
    }
  },
  computed: {
    title() {

      return '绑定主贷人信息'
    },
  },
  created() {
    this.def = { ...this.params }
  },

  methods: {
    init(orderId , id) {
      this.orderId = orderId
      this.id = id
      this.visible = true
      this.list()
    },
    list() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true

      this.$request.ciPersons(params).then(resp => {
        this.loading = false
        if (resp.code) {
          this.$Message.error(resp.msg)
        } else {
          this.data = this.$utils.conv(resp.data.list || [], { 'userType': '$debtorType', 'state': '$ciState' , 'creditInquiryTime':'time' })
          this.page.total = resp.data.total || 0
        }
      })
    },

    reset() {
      this.$utils.fill(this.params, this.def)
      this.list()
    },


    handleUpdate() {
      this.modalVisible = false
      this.list()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    viewCreditDetail({row}){
      console.log(this.$refs['dpb'])
      this.$refs['dpb'].init( row.id )
    },
    bind({ row }) {
      let params = {orderId:this.orderId , userType : 0 , creditCode : row.creditCode }
      let exec = this.id ? this.$request.orderPersonUpdate : this.$request.orderPersonCreate

      exec(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.$emit('on-update')
          this.visible = false
        }
        this.loading = false
      })
    },
  }
}

</script>
